import { render, staticRenderFns } from "./EmployeePaystub.vue?vue&type=template&id=2d5ed127&scoped=true&"
import script from "./EmployeePaystub.vue?vue&type=script&lang=ts&"
export * from "./EmployeePaystub.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeePaystub.vue?vue&type=style&index=0&id=2d5ed127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ed127",
  null
  
)

export default component.exports